import { Row } from '../grid';
export default Row;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/row/index.js
// module id = 333
// module chunks = 0